import Lots from './lots';
export default Lots;